var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLine = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.502 4.443a.75.75 0 0 1 .055 1.059l-4.5 5a.75.75 0 0 1-.862.183l-3.99-1.773-2.636 3.076a.75.75 0 1 1-1.138-.976l3-3.5a.75.75 0 0 1 .874-.197l4.002 1.778 4.136-4.595a.75.75 0 0 1 1.059-.055z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLine);
export default ForwardRef;